import React from "react";
import { MessageCircle } from "lucide-react";
import { OwnerExclusiveService } from "../constants/ownerExclusiveServices";
import { buildOwnerServiceWhatsAppUrl } from "../utils/buildOwnerServiceWhatsAppUrl";

interface OwnerServiceCardProps {
  service: OwnerExclusiveService;
}

export default function OwnerServiceCard({ service }: OwnerServiceCardProps) {
  const Icon = service.icon;
  const whatsappUrl = buildOwnerServiceWhatsAppUrl(
    service.contactPhone,
    service.whatsappMessage
  );

  return (
    <article className="flex h-full flex-col rounded-2xl border border-white/[0.08] bg-[#1c2128] p-4">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center self-center rounded-xl border border-[#6ea8ff]/25 bg-[#6ea8ff]/10">
          <Icon className="h-5 w-5 text-[#6ea8ff]" />
        </div>
        <div className="flex min-w-0 flex-1 flex-col justify-center">
          <span className="text-[0.6rem] font-semibold uppercase leading-tight tracking-[0.12em] text-[#6e7681]">
            {service.tag}
          </span>
          <h3 className="mt-0.5 text-sm font-bold leading-tight text-[#f0f6fc]">
            {service.title}
          </h3>
        </div>
      </div>

      <p className="mt-3 flex-1 text-xs leading-relaxed text-[#8b949e] sm:text-sm">
        {service.description}
      </p>

      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full border border-[#6ea8ff]/35 bg-transparent px-4 py-2.5 text-xs font-semibold text-[#6ea8ff] transition-colors hover:border-[#6ea8ff]/55 hover:bg-[#6ea8ff]/10 sm:text-sm"
      >
        <MessageCircle className="h-4 w-4 shrink-0" />
        Fale conosco
      </a>
    </article>
  );
}
